<template>
  <div class="Investment-box">
    <div class="head-text">
        <h1>Investment</h1>
    </div>
    <div class="card-box">
      <h4>Select your option</h4>
      <v-row>
      	<template>
          <v-card
          	v-for="categoryList in category"
          	:key="categoryList.id"
            class="mx-auto"
            outlined
            @click="subcategory(categoryList.childsubcategory,categoryList.subcategory_name,categoryList.id,categoryList.jump_to_router)"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
                	<v-img
        			max-height="39"
        			max-width="39"
        			:src="webIcon + categoryList.web_icon"
                	>
                	</v-img>
                </div>
                <v-list-item-title>{{categoryList.subcategory_name}}</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="subcategory(categoryList.childsubcategory,categoryList.subcategory_name,categoryList.id,categoryList.jump_to_router)" text> 
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { GET_CATEGORY_DATA } from "../../store/actions.type";
import ApiService from '../../api/api.service';
import JwtService from ".././common/jwt.service";
import { isEmpty } from 'lodash';

   export default {
       data: () => ({
       	category:'',
       	webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
      }),
        mounted (){
          this.categoryData();
          Fire.$on("categoryData", () => {
            this.categoryData();
          });

          if (isEmpty(this.$store.getters.getNewCategoryData)) {
             this.categoryData();
          } else {
             let categoryData = this.$store.getters.getNewCategoryData.data;
              this.category = categoryData;
          }

          },
       methods: {
          subcategory(data,subcategoryName,id,jump_to_router){
            let current_category_data = { 
              current_category_id:id,
            };
            this.updateCurrentCategoryIdData('commitCurrentCategoryIdData', current_category_data);
            if(id == 1){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 1 } });
            }
            else if(id == 2){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 2 }});
            }else if(id == 4){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 4 }});
            }else if(id == 7){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 7 }});
            }else if(id == 8){
              this.$router.push({ name: 'commodities-dashboard', params: { current_category_id : 8 }});
            }else if(id == 6){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 6 }});
            }else if(id == 3){
              this.$router.push({ name: 'real-state-dashboard', params: { current_category_id : 3 }});
            }else if(id == 9){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 9 }});
            }
            else if(id == 5){
              this.$router.push({ name: jump_to_router, params: { current_category_id : 5 }});
            }
            else{
              
            }

            // id == 1 ? this.$router.push({ name: jump_to_router, params: { current_category_id : this.CurrentCategoryIdData.current_category_id } }) : id == 2 ? this.$router.push({ name: jump_to_router, params: { current_category_id : this.CurrentCategoryIdData.current_category_id }}): id == 4 ? this.$router.push({ name: jump_to_router}) : id == 7 ? this.$router.push({ name: jump_to_router}) : id == 8 ? this.$router.push({ name: 'commodities-dashboard'}):id == 6 ? this.$router.push({ name: 'retirement-dashboard'}) : id == 3 ? this.$router.push({ name: 'real-state-dashboard'}) : '';
          },
          categoryData(){
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            this.$store.dispatch(GET_CATEGORY_DATA, {
                  data: {
                    aws_cognito_id:cognito_idp,
                    category_id:2,
                  },
                  api: 'subcategory-listing',
              })
              .then(() => {
                let categoryData = this.$store.getters.getNewCategoryData.data;
                this.category = categoryData;
              });
          }
}
}
</script>